import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import {SearchBar} from "@mnjsplatform/components/lib/common/SearchBar";
import BaseMnTree from "@mnjsplatform/components/lib/common/BaseMnTree";
import {renderHTML} from "@mnjsplatform/data/lib/utils/htmlUtils";
import ViewPerson from "./ViewPerson";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";
import queryString from "query-string";
import {GlobalDebugMode} from "@mnjsplatform/data";
import DropDownMenuCombo from "@mnjsplatform/components/lib/common/DropdownMenu/DropDownMenuCombo";
import ReportPlaceholder from "../Common/ReportPlaceholder";
import {fn} from "moment";

class OrgChart extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            inOperation: true,
            showPersonInfo: false,
            subTabNum: null,
            selectedTabNums: [],
            selectedInMyList: [],
            filterValues: {},
            selectedFilter: null,
            showAllRows: false,
            useMyList: false,
            myListTabNums: []
        }
    }

    componentDidMount = async () => {
        await this.initialize();
    }

    initialize = async () => {
        const self = this;
        self.setState({inOperation: true});
        try {
            await self.props.dispatch(self.props.dataItem_Departments.execute({ShowAll: 0}, {
                treeExpanded: false, withParams: false, newItem: true
            }));
            await self.props.dispatch(self.props.dataItem_Departments.goto(-1));
            await self.props.dispatch(self.props.AdmStructSetParamForPO_GetUserDepartment.execute());

            if (self.props.AdmStructSetParamForPO_GetUserDepartment.rowsCount() > 0) {
                const rowKey = self.props.AdmStructSetParamForPO_GetUserDepartment.getRowKeyByIndex(0);
                await self.props.dispatch(self.props.dataItem_Departments.treeSetCurrentRow(rowKey));
            }
            await self.props.dispatch(self.props.dataItem_Persons.execute({}, {withParams: true, newItem: true}));
            await self.props.dispatch(self.props.dataItem_PersonsParams.setField(0, 'IncludeSub', 1));
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({inOperation: false});
        }
    }
    getTabNums = () => {
        let result = [];
        if (this.state.useMyList) {
            result = this.state.selectedInMyList.length > 0
                ? this.state.selectedInMyList.map(tabNum => ({TabNum: tabNum}))
                : this.props.dataItem_Persons_MyList.dataTable().map(r => ({TabNum: r.SubTabNum}));
        }
        else{
            result = this.state.selectedTabNums.length > 0
                ? this.state.selectedTabNums.map(tabNum => ({TabNum: tabNum}))
                : this.props.dataItem_Persons.dataTable().map(r => ({TabNum: r.SubTabNum}));
        }
        return result;
    }
    paramRender1 = (h) => {
        return (<>
                <div className="row">
                    <div className="col-md-12">
                        {h.fs.map((fi) => {
                            const fn = fi.Name;
                            return (<React.Fragment key={fn}>
                                <div className="row">
                                    <div className="col-md-3 field-title">
                                        {h.lbl(fn)}
                                    </div>
                                    <div className="col-md-9">
                                        {h.ed(fn)}
                                    </div>
                                </div>
                                <hr/>
                            </React.Fragment>)
                        })}
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-2">
                        {i18next.t("Search_By_FIO")}:
                    </div>
                    <div className="col-md-7" style={{height: "32px"}}>
                        <SearchBar dataItem={this.props.titleInfoItem}/>
                    </div>
                    <div className="col-md-3">
                        <button type="button" className="btn btn-regular -goahead  ml1ex"
                                data-dismiss="modal">{i18next.t("Advanced_Search")}</button>
                    </div>
                </div>
            </>)
    }
    clearSelectedPersons = () => {
        this.setState((this.state.useMyList ? {selectedInMyList: []}: {selectedTabNums: []}));
    }
    selectAllPersons = async () => {
        if (this.state.useMyList) {
            this.setState({selectedInMyList: this.state.myListTabNums});
        } else {
            this.setState({selectedTabNums: this.props.dataItem_Persons.dataTable().map(r => r.SubTabNum)});
        }
    }
    renderPersonButtons = () => {
        return (<div className="modal-footer text-right btn-group">
            {this.props.dataItem_Persons.isInitialized && this.props.dataItem_Persons.rowsCount() > 0 &&
                <>
                <button type="button" className="btn btn-regular -godefault ml1ex"
                        data-dismiss="modal" onClick={() => {
                    this.setState({showAllRows: !this.state.showAllRows});
                }}>{i18next.t((this.state.showAllRows ? "Show_By_Pages" : "Show_All"))}</button>
                <button type="button" className="btn btn-regular -godefault ml1ex"
                        data-dismiss="modal" onClick={this.selectAllPersons}>{i18next.t("Select_All")}</button>
            </>}
            {((!this.state.useMyList && this.state.selectedTabNums.length > 0) || (this.state.useMyList && this.state.selectedInMyList.length > 0)) && <>
                <button type="button" className="btn btn-regular -goescape ml1ex"
                        data-dismiss="modal"
                        onClick={this.clearSelectedPersons}>{i18next.t("Cancel_All_Selected")}</button>
                <ReportPlaceholder reportKey="ListPersForOD" reportId="ListPersForOD" title={i18next.t("Export_All_Selected")}>
                    {(reportParamsItem, build) => {
                        return (<>
                                <button type="button" className="btn btn-regular -goahead ml1ex"
                                        data-dismiss="modal" onClick={async (e) => {
                                    e.preventDefault();
                                    await this.props.dispatch(reportParamsItem.setField(0, "TabNumSet", this.getTabNums()));
                                    await build();
                                }}>{i18next.t("Export_All_Selected")}
                                </button>
                            </>);
                    }}
                </ReportPlaceholder>
            </>}
        </div>)
    }
    renderTreeCell = (cellParams) => {
        if (cellParams.fieldInfo.Name === 'IsSet') {
            return renderHTML(cellParams.row[cellParams.fieldInfo.Name]);
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }
    applyFilters = async () => {
        if (this.state.filterValues) {
            for (const filterId in this.state.filterValues) {
                await this.props.dispatch(this.props.dataItem_PersonsParams.setField(0, filterId, this.state.filterValues[filterId].value));
            }
        }
        await this.props.dispatch(this.props.dataItem_Persons.applyParams(this.props.dataItem_PersonsParams));
    }
    resetFilters = async () => {
        this.setState({filterValues: {}});
        await this.refreshPersons();
    }
    refreshPersons = async () => {
        await this.props.dispatch(this.props.dataItem_Persons.refresh({}, {withParams: true, newItem: true}))
    }
    getSelected = (state) => {
        return state.useMyList ? state.selectedInMyList : state.selectedTabNums;
    }

    cellClick = (row, fieldInfo, e) => {
        if (fieldInfo.Name === "FIO" || fieldInfo.Name === "Contacts") {
            //this.setState({showPersonInfo: true, subTabNum: row.SubTabNum});
        } else {
            this.setState((state, props) => {
                let newSelectedTabNums;
                if (row.IsChecked === 0) {
                    newSelectedTabNums = this.getSelected(state).filter(tn => true);
                    newSelectedTabNums.push(row.SubTabNum);
                } else {
                    newSelectedTabNums = this.getSelected(state).filter(tn => tn !== row.SubTabNum);
                }
                return state.useMyList
                    ? {
                        selectedInMyList: newSelectedTabNums
                    }
                    : {
                        selectedTabNums: newSelectedTabNums
                    };
            });
        }
    }
    gridRowStyleProvider = (rowIndex, row) => {
        let style = {cursor: "pointer"};
        if (row.IsChecked === 1) {
            return {
                ...style, fontWeight: "bold", backgroundColor: "lightgrey"
            };
        }
        return style;
    }

    nodeRender = (row, rowIndex, lbl) => {
        const isSelectedRow = row.IsSet === 1;
        return (<span className="w-100 small" style={{cursor: "pointer"}}
                      title={i18next.t('Choose')}>
                              <input className="checkbox"
                                     type="checkbox"
                                     style={{cursor: "pointer"}}
                                     checked={isSelectedRow}
                                     disabled={false}
                                     onChange={async () => {
                                         await this.props.dispatch(this.props.dataItem_Departments.setField(rowIndex, 'IsSet', (isSelectedRow ? 0 : 1)));
                                         await this.props.dispatch(this.props.dataItem_Departments.save(rowIndex));
                                         await this.applyFilters();
                                         this.afterApplyFilter();
                                     }}
                              />
                &nbsp;
                <span style={{
                    /*color: (isSelectedRow ? 'white' : ''),*/
                    background: (isSelectedRow ? 'lightgrey' : ''), fontWeight: (isSelectedRow ? 'bold' : '')
                }}>{lbl}</span>
            </span>);
    }
    getImageUrl = (subTabNum) => {
        const qs = queryString.stringify({tabNum: subTabNum});
        return window.config.apiRoot + "/PaPersonImage/GetPersonImage?" + qs;
    }
    renderPersonPhoto = (subTabNum) => {
        return <div className="m-2 d-block"><img src={this.getImageUrl(subTabNum)} alt="Person Image"/></div>;
    }
    renderPersonRow = (row, rowIndex, renderRowDefault) => {
        let rRow = {
            ...row, IsChecked: this.getSelected(this.state).some(tn => tn === row.SubTabNum) ? 1 : 0,
            InMyList: this.state.myListTabNums.some(tn => tn === row.SubTabNum) ? 1 : 0
        };
        return renderRowDefault(rRow, rowIndex);
    }
    renderPersonCell = (cellParams) => {
        function formatPhoneNumber(phone) {
            return phone;
        }

        if (cellParams.fieldInfo.Name === "IsChecked") {
            return <input type="checkbox" className="checkbox" checked={cellParams.row.IsChecked === 1}
                          style={{cursor: "pointer"}}
                          onChange={() => {
                          }}/>;
        } else if (cellParams.fieldInfo.Name === 'IsSet') {
            return renderHTML(cellParams.row[cellParams.fieldInfo.Name]);
        } else if (cellParams.fieldInfo.Name === 'FIO') {
            return <ActionLink onSelect={() => {
                this.setState({showPersonInfo: true, subTabNum: cellParams.row.SubTabNum})
            }}>
                <div className="row" style={{cursor: "pointer"}}>
                    <div className="col-md-3 align-content-center" style={{textAlign: "center"}}>
                        {cellParams.row.InMyList === 1 && <i className="zmdi zmdi-check-circle" title={i18next.t("In_My_List")}/>}
                        {this.renderPersonPhoto(cellParams.row.SubTabNum)}
                    </div>
                    <div className="col-md-6">
                        {cellParams.row[cellParams.fieldInfo.Name]}
                        <div className="field-title text-left">
                            {cellParams.row.AddressName}
                        </div>
                    </div>
                </div>
            </ActionLink>
        } else if (cellParams.fieldInfo.Name === 'Contacts') {
            return <div className="text-nowrap">
                {cellParams.row.EMail && <div className="row"><a href={`mailto://${cellParams.row.EMail}`}><i
                    className="zmdi zmdi-email"></i>&nbsp;{cellParams.row.EMail}</a></div>}
                {cellParams.row.WorkPhone &&
                    <div className="row"><a href={`tel:${formatPhoneNumber(cellParams.row.WorkPhone)}`}><i
                        className="zmdi zmdi-smartphone"></i>&nbsp;{cellParams.row.WorkPhone}</a></div>}
                {cellParams.row.WorkShortPhone &&
                    <div className="row"><i className="zmdi zmdi-phone-ring"></i>&nbsp;{cellParams.row.WorkShortPhone}
                    </div>}
                {cellParams.row.WorkStatPhone &&
                    <div className="row"><a href={`tel:${formatPhoneNumber(cellParams.row.WorkStatPhone)}`}><i
                        className="zmdi zmdi-phone"></i>&nbsp;{cellParams.row.WorkStatPhone}</a></div>}
            </div>
        }
        return cellParams.renderCellDefault(cellParams.row, cellParams.fieldInfo, cellParams.fieldIndex);
    }
    selectAddress = async (e, rowParams) => {
        if (e) e.preventDefault();
        await this.props.dispatch(rowParams.dataItem.setField(rowParams.rowIndex, 'IsSet', (rowParams.row.IsSet === 1 ? 0 : 1)));
        await this.props.dispatch(rowParams.dataItem.save(rowParams.rowIndex));
    }
    renderSubgridRowEx = (rowParams) => {
        return (<div style={{cursor: "pointer"}} key={rowParams.rowIndex}
                     onClick={(e) => this.selectAddress(e, rowParams)}>
            <input type="checkbox" className="checkbox" checked={rowParams.row.IsSet === 1}
                   style={{cursor: "pointer"}} onChange={() => {
            }}/>&nbsp;
            {(rowParams.dataItem.rawData.ItemId === 'AdmStruct.SelAddressListForPO' ? rowParams.row.AddressName : rowParams.row.AltOrgStructName)}
        </div>)
    }
    afterApplyFilter = () => {
        if (this.props.dataItem_Persons.isInitialized && this.state.selectedTabNums.length > 0 && this.state.selectedTabNums.some(tn => !this.props.dataItem_Persons.dataTable().some(r => r.SubTabNum === tn))) {
            let newSelectedTabNums = this.state.selectedTabNums.filter(tn => this.props.dataItem_Persons.dataTable().includes(tn))
            this.setState({selectedTabNums: newSelectedTabNums});
        }
    }
    renderFilters = (h) => {
        const getFilter = (index) => {
            const fieldName = h.fs[index].Name;
            const label = h.lbl(fieldName);
            const control = h.ed(fieldName);
            return <div className="col-4" key={`${fieldName}_filter_subdiv`}>
                <span className="field-title text-left">{label}:&nbsp;</span>
                <span className="">{control}</span>
            </div>
        }
        const filters = h.fs.filter(fi => !fi.IsHidden);
        const filterDivs = [];
        let index = 0;
        do {
            if (index >= filters.length)
                break;
            const fieldName = h.fs[index].Name;
            filterDivs.push(
                <div className="row" id={`${fieldName}_filter`} key={`${fieldName}_filter`}>
                    {getFilter(index)}
                    {index + 1 < filters.length ? getFilter(index + 1) : null}
                </div>);
            index = index + 2;
        }
        while (index < filters.length);

        return (<>
            {filterDivs}
        </>)
    }
    renderAdvancedFilters = () => {
        if (!this.props.dataItem_PersonsParams.isInitialized) return null;
        const menuAdapter = new FilterMenuProvider(this.props.dataItem_PersonsParams, this.state.selectedFilter);
        let filterValues = Object.assign({}, this.state.filterValues);
        const filterId = this.state.selectedFilter ? this.state.selectedFilter : menuAdapter.getMenuItems()[0].MenuItemId;
        return <>
            <div className="row mt-2">
                <div className="col-md-8 d-flex">
                    <DropDownMenuCombo menuAdapter={menuAdapter} className="pe-auto mr-1" style={{top: '1px'}}
                                       onSelected={(menuItem) => {
                                           this.setState({selectedFilter: menuItem.MenuItemId});
                                       }}/>
                    <input ref={x => this.inputFilterValue = x} type="text" className="form-control"
                           placeholder={i18next.t("Value")} readOnly={false}/>
                </div>
                <button type="button" className="btn btn-regular -goahead col-md-3"
                        onClick={async (e) => {
                            e.preventDefault();
                            filterValues[filterId] = {
                                header: menuAdapter.getDropDownText(), value: this.inputFilterValue.value
                            };
                            this.setState({filterValues: filterValues}, () => {
                                this.inputFilterValue.value = ''
                            })
                        }}>{i18next.t("Add_Search_Criteria")}</button>
            </div>
            <div className="alert-warning mt-1">
                {Object.keys(this.state.filterValues).map((filterId) => {
                    const filterValue = this.state.filterValues[filterId];
                    if (!filterValue || !filterValue.value) {
                        return null;
                    }
                    return (<span key={filterId} className="mr-2">{`${filterValue.header}=[${filterValue.value}]`}<a
                        href="" className=""
                        onClick={(e) => {
                            e.preventDefault();
                            let filterValues = Object.assign({}, this.state.filterValues);
                            if (filterValues.hasOwnProperty(filterId)) {
                                filterValues[filterId].value = null;
                                this.setState({filterValues: filterValues});
                            }
                        }}><i className="zmdi zmdi-close zmdi-hc-lg pe-auto align-middle ml-1"/></a></span>);
                })}
            </div>
        </>
    }

    checkPresence = (sourceList, newValues, inList) => {
        let sourceTabNums = new Set(sourceList);
        return newValues.find(value => inList ? sourceTabNums.has(value) : !sourceTabNums.has(value));
    }
    saveToMyList = () => {
        let newTabNums = new Set(this.state.myListTabNums); // Используем Set для отслеживания добавленных элементов
        this.state.selectedTabNums.forEach(tabNum => {
            if (!newTabNums.has(tabNum)) {
                newTabNums.add(tabNum);
            }
        });
        this.setState({myListTabNums: Array.from(newTabNums), selectedTabNums: []}, this.refreshMyList);
    }
    deleteFromMyList = () => {
        let newTabNums = new Set(this.state.myListTabNums); // Используем Set для отслеживания добавленных элементов
        this.state.selectedInMyList.forEach(tabNum => {
            if (newTabNums.has(tabNum)) {
                newTabNums.delete(tabNum);
            }
        });
        this.setState({useMyList: newTabNums.size > 0, myListTabNums: Array.from(newTabNums), selectedInMyList: []}, this.refreshMyList);
    }
    refreshMyList = async() => {
        const tabNums = this.state.myListTabNums.join(",");
        await this.props.dispatch(this.props.dataItem_Persons_MyList.initialize({TabNumList: tabNums}, {newItem: true}));
    }
    showMyList = async() => {
        this.setState({useMyList: !this.state.useMyList});
    }

    renderMyListButtons = () => {
        return (
            <>
                {
                    this.state.myListTabNums.length > 0 &&
                    <button type="button" className="btn btn-regular -godefault ml1ex" data-dismiss="modal"
                            onClick={this.showMyList}>
                        <i className="fa fa-users"/>&nbsp;
                        {i18next.t((this.state.useMyList ? 'AllEmployees' : 'MyList'))}
                    </button>
                }
                {
                    !this.state.useMyList && this.state.selectedTabNums.length > 0 && this.checkPresence(this.state.myListTabNums, this.state.selectedTabNums, false) &&
                    <button type="button" className="btn btn-regular -godefault ml1ex"
                            data-dismiss="modal" onClick={this.saveToMyList}>
                        <i className="fa fa-user-plus"/>&nbsp;{i18next.t('InMyList')}
                    </button>
                }
                {
                    this.state.useMyList && this.state.selectedInMyList.length > 0 &&
                    <button type="button" className="btn btn-regular -godefault ml1ex" data-dismiss="modal"
                            onClick={this.deleteFromMyList}>
                        <i className="fa fa-user-minus"/>&nbsp;{i18next.t('DeleteFromMyList')}
                    </button>
                }
            </>
        )
    }

    render() {
        /*
                if(this.state.inOperation)
                    return null;
        */
        const includeSub = this.props.dataItem_PersonsParams.getField(0, 'IncludeSub') === 1;
        const titleDepartments = <>
            <div className="col-md-3">
                <div className="form-check">
                    <label className="form-check-label text-color" htmlFor="checkIncludeSub">
                        {i18next.t("IncludeSubordinate")}:
                    </label>
                    &nbsp;
                    <input type="checkbox"
                           id="checkIncludeSub"
                           className="checkbox"
                           style={{cursor: "pointer"}}
                           checked={includeSub}
                           onChange={async () => {
                               await this.props.dispatch(this.props.dataItem_PersonsParams.setField(0, 'IncludeSub', (includeSub ? 0 : 1)));
                               //                              await this.props.dispatch(this.props.dataItem_PersonsParams.save(0));
                               await this.applyFilters();
                               this.afterApplyFilter();
                           }}
                    />
                </div>
            </div>
            <div className="col-md-5">
                <button type="button" className="btn btn-regular -goescape ml1ex"
                        onClick={async (e) => {
                            if (e) e.preventDefault();
                            await this.props.dispatch(this.props.dataItem_Departments.reset());
                            await this.props.dispatch(this.props.dataItem_Departments.execute({ShowAll: 1}, {
                                withParams: false, newItem: true
                            }));
                            await this.props.dispatch(this.props.dataItem_Departments.goto(-1));
                            await this.props.dispatch(this.props.dataItem_Persons.refresh());
                        }}
                >{i18next.t("ResetSelectedDepartments")}</button>
            </div>
        </>;

        return (<>
            {!this.state.useMyList && <>
            <PlaceholderWrapper placeholderId="10"
                                title={i18next.t("Departments")}
                                addHeaderTitle={titleDepartments}
                                showSplitterLine={false}
                                canCollapse={true}>
                <div style={{maxHeight: '300px', overflow: 'auto', lineHeight: 'normal'}}>
                    {this.props.dataItem_Departments.isInitialized && !this.state.inOperation &&
                        <BaseMnTree dataItem={this.props.dataItem_Departments} dispatch={this.props.dispatch}
                                    nodeRender={this.nodeRender}
                                    classNameLabel="lt-label w-100"
                                    treeRowStyle={{}}
                                    scrollToParams={{behavior: 'smooth', block: 'center'}}
                            //                               renderRow={this.renderTreeRow}
                        />}
                </div>
            </PlaceholderWrapper>
            <PlaceholderWrapper placeholderId="20" title={i18next.t("Filters")}
                                addHeaderTitle={<>
                                    <button type="button" className="btn btn-regular -goahead"
                                            onClick={this.applyFilters}>{i18next.t("Accept")}</button>
                                    <button type="button" className="btn btn-regular -goescape"
                                            onClick={this.resetFilters}>{i18next.t("Reset")}</button>
                                </>}
                                showHeaderTitle={true}
                                showSplitterLine={false}
                                canCollapse={true}>
                {this.props.dataItem_Persons.isInitialized && <ComplexParam dataItem={this.props.dataItem_PersonsParams}
                                                                            parentDataItem={this.props.dataItem_Persons}
                                                                            renderParams={this.renderFilters}
                                                                            renderSubgridRowEx={this.renderSubgridRowEx}
                                                                            maxSubgridWidthBody=""
                                                                            afterApplyParams={this.afterApplyFilter}
                                                                            showSubgridHeader={false}
                                                                            autoApplyParams={false}
                                                                            applyOnEnterKey={true}
                />}
                {this.renderAdvancedFilters()}
            </PlaceholderWrapper>
            </>}
            <PlaceholderWrapper placeholderId="30" title={i18next.t(this.state.useMyList ? 'MyList' : "Employees")}
                                staticTitle={i18next.t('EmployeesList')}
                                addHeaderTitle={<><span className="text-info">{i18next.t('FoundEmployees', {count: this.props.dataItem_Persons.rowsCount()})}</span>
                                    &nbsp;
                                    <span className="text-warning">({i18next.t('SelectedEmployees', {count: this.state.selectedTabNums.length})}</span>
                                    {this.renderMyListButtons()}
                                </>}
                                showSplitterLine={false}
                                canCollapse={true}>
                {this.renderPersonButtons()}
                {GlobalDebugMode && this.state.myListTabNums &&
                    <div key={"debug-myListTabNums"}>MyList count: {this.state.myListTabNums.length} TabNums: {this.state.myListTabNums.join(', ')}</div>}
                {GlobalDebugMode && this.state.selectedTabNums &&
                    <div key={"debug-selectedTabNums"}>Selected count: {this.state.selectedTabNums.length} TabNums: {this.state.selectedTabNums.join(', ')}</div>}
                {GlobalDebugMode && this.state.selectedInMyList &&
                    <div key={"debug-selectedInMyList"}>Selected count: {this.state.selectedInMyList.length} TabNums: {this.state.selectedInMyList.join(', ')}</div>}
                {((this.state.useMyList && this.props.dataItem_Persons_MyList.isInitialized) || (!this.state.useMyList && this.props.dataItem_Persons.isInitialized)) &&
                    <GridView dataItem={(this.state.useMyList ? this.props.dataItem_Persons_MyList : this.props.dataItem_Persons)}
                                                                        renderCellEx={this.renderPersonCell}
                                                                        renderRow={this.renderPersonRow}
                                                                        onCellClick={this.cellClick}
                                                                        updateStateFlag={(this.state.useMyList ? {f: this.state.selectedTabNums} : {f: this.state.selectedInMyList})}
                                                                        rowStyleProvider={this.gridRowStyleProvider}
                                                                        allowPagination={!this.state.showAllRows}
                                                                        pageSize={10}
                                                                        readOnly={true}
                                                                        activePageSize={10}
                    //cellLongTextMaxLength={30}
                />}
            </PlaceholderWrapper>
            {this.state.showPersonInfo && <ViewPerson subTabNum={this.state.subTabNum} onClose={() => {
                this.setState({showPersonInfo: false});
            }}/>}
        </>)
    }
}

OrgChart.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem_Departments: PropTypes.object,
    dataItem_Persons: PropTypes.object,
    dataItem_PersonsParams: PropTypes.object,
    dataItem_Persons_MyListParams: PropTypes.object,
    AdmStructSetParamForPO_GetUserDepartment: PropTypes.object
}

OrgChart.defaultProps = {};

function mapStateToProps(state, ownProps) {
    return {
        dataItem_Departments: state.orgChartState.AdmStruct_GetTreeForPO,
        dataItem_Person: state.aboutMeState.ListForPODesc1,
        dataItem_Persons: state.orgChartState.AdmStruct_GetPersonsForPO,
        dataItem_PersonsParams: state.orgChartState.AdmStruct_GetPersonsForPOParams,
        dataItem_Persons_MyList: state.orgChartState.AdmStruct_GetEmpListForPO,
        dataItem_Persons_MyListParams: state.orgChartState.AdmStruct_GetEmpListForPOParams,
        AdmStructSetParamForPO_GetUserSelection: state.orgChartState.AdmStructSetParamForPO_GetUserSelection,
        AdmStructSetParamForPO_GetUserDepartment: state.orgChartState.AdmStructSetParamForPO_GetUserDepartment
    }
}

export default connect(mapStateToProps)(OrgChart);

class FilterMenuProvider {
    constructor(dataItem, activeItem) {
        this.items = [];
        if (dataItem && dataItem.isInitialized) {
            for (let fieldInfo of dataItem.rawData.ResultFieldInfo) {
                if (fieldInfo.Header && fieldInfo.IsHidden) {
                    this.items.push({
                        MenuItemId: fieldInfo.Name,
                        MenuText: fieldInfo.Header, //IsActive: fieldInfo.Name === activeItem
                    });
                }
            }
        }
        this.activeItem = activeItem || (this.items.length > 0 ? this.items[0].MenuItemId : null);
    }

    getMenuItems() {
        return this.items;
    }

    getVisibleItemsCount() {
        return 1;
    }

    getDropDownText() {
        if (!this.items) return null;
        const activeItem = this.items.find(i => i.MenuItemId === this.activeItem);
        if (activeItem) {
            return activeItem.MenuText + "";
        }

        return this.items[0].MenuText;
    }
}